import {
  CategoryConfigurationDefinitionResponse,
  ConfigurationFieldType,
  ConfigurationSectionType,
} from '@ydistri/api-sdk';

const sectionTypeTitleMap: Record<ConfigurationSectionType, string> = {
  [ConfigurationSectionType.General]: '',
  [ConfigurationSectionType.PotentialSource]: 'Source',
  [ConfigurationSectionType.PotentialSourceForcedSubsection]: 'Source Forced',
  [ConfigurationSectionType.PotentialSourceStandardSubsection]: 'Source',
  [ConfigurationSectionType.PotentialTarget]: 'Target',
};

const overriddenFieldTypeTitle: Partial<Record<ConfigurationFieldType, string>> = {
  [ConfigurationFieldType.PtRequestList]: 'Request list',
};

export const getSectionTitle = (sectionType: ConfigurationSectionType): string => {
  return sectionTypeTitleMap[sectionType];
};

export const getSectionTitleFromDefinition = (
  definition: CategoryConfigurationDefinitionResponse | undefined,
): string => {
  if (!definition) return '';
  const sectionTitle = getSectionTitle(definition.sectionType);
  return sectionTitle ? `${sectionTitle} -` : '';
};
export const getDefinitionByFieldType = (
  ft: ConfigurationFieldType,
  configurationDefinitions: CategoryConfigurationDefinitionResponse[],
): CategoryConfigurationDefinitionResponse | undefined => {
  return configurationDefinitions.find(cd => cd.fieldType === ft);
};

/**
 * Return overridden field title different from the one defined on the backend.
 * Some backend-defined titles are not usable in other contexts than the one they were created for, so we need to override them in some cases.
 * @param configurationFieldType the field type for which to return overridden title
 * @param originalTitle backend-defined title to be returned when no overridden title exists
 */
export const overrideConfigurationFieldTypeTitle = (
  configurationFieldType: ConfigurationFieldType,
  originalTitle: string,
): string => {
  return overriddenFieldTypeTitle[configurationFieldType] ?? originalTitle;
};
